import { Button, Grid } from "@material-ui/core";
import { Auth } from "aws-amplify";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./genai.css";

export default function AuditCoach() {
  const [genaiaccess, setgenaiaccess] = useState(false);

  useEffect(() => {
    const username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    const userdata = localStorage.getItem(
      `CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`,
    );
    const jsondata = JSON.parse(userdata);
    const emailObj = jsondata.UserAttributes.find(
      (item) => item.Name === "email",
    );
    const email = emailObj?.Value || "";

    setgenaiaccess(email.includes("genai2244"));
  }, []);

  async function signOut() {
    try {
      await Auth.signOut({ global: true });
      window.location.reload();
    } catch (error) {
      // console.log('error signing out: ', error);
    }
  }
  return (
    <div>
      <div>
        <img
          id="backgroundmainimageoverlay"
          src="/assets/images/background/g7.mp4"
          alt="background-img"
          style={{
            filter: "opacity(0.2)",
            position: "fixed",
            zIndex: "-3",
            width: "100vw",
            height: "110vh",
            marginTop: "-10vh",
            overflow: "hidden",
          }}
        />
        <img
          style={{ zIndex: "-4" }}
          id="backgroundmainimage"
          src="/assets/images/background/MainBackground.png"
          alt="main=background-img"
        />
      </div>
      <div className="container-fluid navcontent">
        <div className="row justify-content-between">
          <div className="col-auto align-self-end">
            <div>
              <Grid
                style={{ display: "flex", position: "relative", zIndex: "4" }}
              >
                <Link to="/departments">
                  <Button variant="contained" component="span" color="primary">
                    Back
                  </Button>
                </Link>
              </Grid>
            </div>
          </div>
          <div className="col-auto align-self-end basicheader">
            <h2 style={{ paddingTop: "10vh !important", fontWeight: "bold" }}>
              Generative AI for Audit
            </h2>
          </div>
          <div className="col-auto align-self-end">
            <Button
              style={{
                backgroundColor: "#ffa502",
                position: "relative",
                zIndex: "4",
              }}
              variant="contained"
              onClick={() => {
                signOut();
              }}
              color="primary"
              component="span"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>

      {genaiaccess ? (
        <div>
          <div className="exp-container" style={{ width: "90vw" }}>
            <div className="exp">
              <h2>Data Analytics</h2>
              <img
                className="exp-img"
                alt="chatbot2 img"
                src="/assets/images/chatbot2.png"
                loading="eager"
              />
              <Link to="/audit-data-analytics">
                <p>Open</p>
              </Link>
            </div>
            <div className="exp">
              <h2>Procurement Risk Analysis</h2>
              <img
                className="exp-img"
                alt="finance-comparison-img"
                src="/assets/images/finance-comparison.png"
                loading="eager"
              />
              <Link to="/procurement-risk-analysis">
                <p>Open</p>
              </Link>
            </div>
            <div className="exp" style={{ padding: "1rem" }}>
              <h2>Policy Document Chatbot</h2>
              <img
                className="exp-img"
                alt="prompt-finance-img"
                src="./assets/images/prompt-finance.jpg"
                loading="eager"
              />
              <Link to="/policy-document">
                <p>Open</p>
              </Link>
            </div>
          </div>
          <div className="exp-container" style={{ width: "90vw" }}>
            <div className="exp">
              <h2>MSA Risk Analysis</h2>
              <img
                className="exp-img"
                alt="chatbot-img"
                src="/assets/images/chatbot2.png"
                loading="eager"
              />
              <Link to="/msa-risk-analysis">
                <p>Open</p>
              </Link>
            </div>
            <div className="exp">
              <h2>
                Prompt Engineering <br /> using Policy Documenet
              </h2>
              <img
                className="exp-img"
                alt="designer-img"
                src="/assets/images/Designer.png"
                loading="eager"
              />
              <Link to="/prompt-engineering-policy">
                <p>Open</p>
              </Link>
            </div>
            <div className="exp">
              <h2>Invoice to PO Matching</h2>
              <img
                className="exp-img"
                alt="invoice-img"
                src="/assets/images/invoice.jpg"
                loading="eager"
              />
              <Link to="/audit-invoice-po">
                <p>Open</p>
              </Link>
            </div>
          </div>
          <div className="exp-container" style={{ width: "90vw" }}>
            <div className="exp" style={{ padding: "1rem" }}>
              <h2>Supplier Quote Comparison</h2>
              <img
                className="exp-img"
                alt="prompt-finance-img"
                src="/assets/images/prompt-finance.jpg"
                loading="eager"
              />
              <Link to="/supplier-quote-comparison">
                <p>Open</p>
              </Link>
            </div>
          </div>
        </div>
      ) : (
        <h2 style={{ color: "white", textAlign: "center" }}>
          You do not have an access to use this section.
        </h2>
      )}
    </div>
  );
}
